import { useState } from 'react';
import Logo from 'v3/components/Logo';

import * as S from './styles';

type ItemType = {
  item: React.ReactNode;
};

export type HeaderTypes = {
  itemList?: ItemType[];
};

const Header = ({ itemList }: HeaderTypes) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <S.MenuContainer>
      <S.Wrapper>
        <S.Container>
          <a aria-label="savings.club website" href=" https://savings.club">
            <Logo />
          </a>

          <S.MobileOnly>
            {itemList?.length && (
              <S.IconWrapper>
                <S.Burger
                  size={24}
                  aria-label="menu icon"
                  $isActive={!isActive}
                  aria-hidden={isActive}
                  onClick={() => setIsActive(true)}
                />
                <S.Close
                  size={24}
                  aria-label="close menu icon"
                  aria-hidden={!isActive}
                  $isActive={isActive}
                  onClick={() => setIsActive(false)}
                />
              </S.IconWrapper>
            )}
          </S.MobileOnly>

          <S.DesktopOnly>
            <nav>
              {itemList && (
                <S.LinksList>
                  {itemList.map((item, key) => (
                    <S.Item key={key}>{item.item}</S.Item>
                  ))}
                </S.LinksList>
              )}
            </nav>
          </S.DesktopOnly>
        </S.Container>
      </S.Wrapper>

      <S.MobileOnly>
        <S.MobileNav $isActive={isActive} aria-hidden={!isActive}>
          {itemList && (
            <S.LinksList>
              {itemList.map((item, key) => (
                <S.Item key={key}>{item.item}</S.Item>
              ))}
            </S.LinksList>
          )}
        </S.MobileNav>
      </S.MobileOnly>
    </S.MenuContainer>
  );
};

export default Header;
